import { Trigger } from '@radix-ui/react-tabs'
import * as React from 'react'

import { styled } from '~/styled'

import { SegmentedControlContext } from './SegmentedControlContext'

const StyledItem = styled(
  Trigger,
  {
    base: [
      'relative',
      'bg-transparent',
      'rounded-md',
      'z-2',
      'min-w-35',
      'border-2',
      'border-transparent',
      'cursor-pointer',
      'select-none',
      'flex',
      'flex-col',
      'items-center',
      'justify-center',
      'data-[state=active]:border-2',
      'data-[state=active]:border-transparent',
      'data-[state=active]:focus-visible:border-primary-800',
      'data-[state=active]:focus-visible:shadow-none',
      'data-[state=active]:font-semibold',
      'data-[state=active]:shadow-none',
      'data-[state=active]:text-(--text-bold)',
      'data-[state=inactive]:font-normal',
      'data-[state=inactive]:text-grey-900',
      'disabled:cursor-not-allowed',
      'disabled:opacity-30',
      'focus-visible:outline-none'
    ],
    variants: {
      theme: {
        primary: [
          'data-[state=inactive]:hover:bg-primary-300',
          'focus-visible:border-primary-800'
        ],
        marsh: [
          'data-[state=inactive]:hover:bg-marsh-300',
          'focus-visible:border-marsh-800'
        ]
      },
      size: {
        sm: ['flex-[unset]', 'gap-3', 'px-6', 'py-4'],
        md: ['flex-1', 'gap-4', 'px-4', 'py-6'],
        lg: ['flex-1', 'gap-4', 'px-4', 'py-6']
      }
    },
    defaultVariants: {
      size: 'md',
      theme: 'primary'
    }
  },
  { enabledResponsiveVariants: true }
)

export const SegmentedControlItem = React.forwardRef<
  HTMLButtonElement,
  Omit<React.ComponentProps<typeof StyledItem>, 'size'>
>(({ children, ...props }, ref) => {
  const { size, theme } = React.useContext(SegmentedControlContext)

  return (
    <StyledItem {...props} theme={theme} size={size} ref={ref}>
      {children}
    </StyledItem>
  )
})

SegmentedControlItem.displayName = 'SegmentedControlItem'
